import { Link, useLocation } from 'react-router-dom';
import type { NeedsAttention } from '../../api/types';
import { ChipInfo } from './ChipInfo';
import { paymentChipHelp } from './chipHelp';
import styles from './ScorecardStrip.module.css';
const items = [
  ['advanceAtRiskOrOverdue', 'Advance at risk/overdue'],
  ['balanceAtRiskOrOverdue', 'Balance at risk/overdue'],
  ['invoiceOverdue', 'Invoice overdue'],
  ['shipperPaymentOverdue', 'Shipper payment overdue'],
  ['approvalsWaiting', 'Approvals waiting'],
  ['paymentClaimsWaiting', 'Payment claims waiting'],
] as const;
export function PaymentAttentionChips({ attention }: { attention: NeedsAttention }) {
  const location = useLocation();
  return (
    <>
      {items.map(([key, label]) => {
        const item = attention[key];
        if (!item || item.count === 0) return null;
        const to =
          key === 'paymentClaimsWaiting'
            ? '/payments?bucket=PAYMENT_CLAIMS&state=BREACHED&mine=true'
            : `/shipments?shipmentIds=${item.shipmentIds.join(',')}&attention=${key}`;
        const params = new URLSearchParams(location.search);
        const selected =
          key === 'paymentClaimsWaiting'
            ? location.pathname + location.search === to
            : location.pathname === '/shipments' &&
              params.get('shipmentIds') === item.shipmentIds.join(',') &&
              params.get('attention') === key;
        return (
          <span key={key} className={styles.chipWithInfo}>
            <Link
              className={`${styles.chip} ${styles.chipWarning} ${selected ? styles.chipActive : ''}`}
              aria-current={selected ? 'page' : undefined}
              to={to}
            >
              <span>{label}</span>
              <span className={styles.chipBadge}>{item.count}</span>
              <span aria-hidden="true">→</span>
            </Link>
            <ChipInfo label={label} text={paymentChipHelp(key)} />
          </span>
        );
      })}
    </>
  );
}
